import * as React from 'react';

class Logout extends React.Component {

    render() {
        return <div>This is Logout page</div>;
    }
}

export default Logout;


// WEBPACK FOOTER //
// ./src/components/Auth/Logout.js